import { createContext } from 'react'

export const ConfigurationContext = createContext<{
  state: any
  dispatch: any
  handleUpdateConfiguration: (
    typeConfigurationOrProcessId: number,
    name: string,
    isCheck?: boolean
  ) => void
  handleChange: (e: any) => void
  editModeButtons: (name: any, isEditable: boolean) => void
  saveModeButtons: (name: any, isCreated: boolean) => void
}>({
  state: undefined,
  dispatch: undefined,
  handleUpdateConfiguration: () => {},
  handleChange: () => {},
  editModeButtons: () => {},
  saveModeButtons: () => {}
})
